import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatChileanMetricsUpdatedParts } from "../../utils/dateUtils";

export type MetricHoverTitleProps = {
  label: string;
  /** ISO timestamp of the snapshot that produced this metric. */
  updatedAt?: string | null;
};

/**
 * Metric tooltip: existing explanation, plus "Actualizado en {date} a las {time}" when known.
 */
export const MetricHoverTitle: React.FC<MetricHoverTitleProps> = ({
  label,
  updatedAt,
}) => {
  const { t, i18n } = useTranslation("miContenido");
  const parts = formatChileanMetricsUpdatedParts(updatedAt, i18n.language);
  const note = parts ? t("tooltips.updatedAt", parts) : null;

  if (!note) return <>{label}</>;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box>{label}</Box>
      <Box
        sx={{
          mt: 0.75,
          fontSize: "0.75rem",
          lineHeight: 1.35,
          fontWeight: 400,
          opacity: 0.85,
        }}
      >
        {note}
      </Box>
    </Box>
  );
};
